export default {
  path: '/equipment-storage',
  component: () => import('@/views/equipment-storage/Index'),
  redirect: { name: 'rentals-active' },
  children: [
    {
      path: 'rentals',
      component: () => import('@/views/equipment-storage/rentals/Index'),
      children: [
        {
          path: '',
          component: () => import('@/views/equipment-storage/rentals/Layout'),
          children: [
            {
              path: '',
              name: 'rentals-active',
              component: () => import('@/views/equipment-storage/rentals/Active'),
              meta: {
                title: 'List of rentals',
                roles: ['general_manager', 'equipment_storage_manager', 'equipment_storage_storekeeper']
              },
            },
            {
              path: 'completed',
              name: 'rentals-completed',
              component: () => import('@/views/equipment-storage/rentals/Completed'),
              meta: {
                title: 'List of rentals',
                roles: ['general_manager', 'equipment_storage_manager', 'equipment_storage_storekeeper']
              },
            },
          ]
        },
        {
          path: ':id',
          name: 'rentals-detail',
          component: () => import('@/views/equipment-storage/rentals/detail/Layout'),
          redirect: { name: 'rental-items' },
          meta: {
            title: 'Rental (ID: 0)',
          },
          children: [
            {
              path: 'rental',
              name: 'rental-items',
              component: () => import('@/views/equipment-storage/rentals/detail/Rental'),
              meta: {
                roles: ['general_manager', 'equipment_storage_manager', 'equipment_storage_storekeeper']
              }
            },
            {
              path: 'purchase',
              name: 'rental-purchase',
              component: () => import('@/views/equipment-storage/rentals/detail/Purchase'),
              meta: {
                roles: ['general_manager', 'equipment_storage_manager', 'equipment_storage_storekeeper']
              }
            },
            {
              path: 'payments',
              name: 'rental-payments',
              component: () => import('@/views/equipment-storage/rentals/detail/Payments'),
              meta: {
                roles: ['general_manager', 'equipment_storage_manager', 'equipment_storage_storekeeper']
              }
            },
          ]
        },
      ]
    },
    {
      path: 'rental-items',
      component: () => import('@/views/equipment-storage/rental-items/Index'),
      children: [
        {
          path: '',
          component: () => import('@/views/equipment-storage/rental-items/Layout'),
          children: [
            {
              path: '',
              name: 'rental-items-active',
              component: () => import('@/views/equipment-storage/rental-items/Active'),
              meta: {
                title: 'Rental items',
                roles: ['general_manager', 'equipment_storage_manager', 'equipment_storage_storekeeper']
              },
            },
            {
              path: 'need-repair',
              name: 'rental-items-repair',
              component: () => import('@/views/equipment-storage/rental-items/NeedRepair'),
              meta: {
                title: 'Rental items',
                roles: ['general_manager', 'equipment_storage_manager', 'equipment_storage_storekeeper']
              },
            },
            {
              path: 'destroyed',
              name: 'rental-items-destroyed',
              component: () => import('@/views/equipment-storage/rental-items/Destroyed'),
              meta: {
                title: 'Rental items',
                roles: ['general_manager', 'equipment_storage_manager', 'equipment_storage_storekeeper']
              },
            },
          ]
        },
        {
          path: ':id',
          name: 'rental-items-detail',
          component: () => import('@/views/equipment-storage/rental-items/Detail'),
          meta: {
            title: 'Rental item (ID: 0)',
            roles: ['general_manager', 'equipment_storage_manager', 'equipment_storage_storekeeper']
          },
        },
      ]
    },
    {
      path: 'purchase-items',
      component: () => import('@/views/equipment-storage/purchase-items/Index'),
      children: [
        {
          path: '',
          name: 'purchase-items',
          component: () => import('@/views/equipment-storage/purchase-items/List'),
          meta: {
            title: 'Purchase items',
            roles: ['general_manager', 'equipment_storage_manager', 'equipment_storage_storekeeper']
          },
        },
        {
          path: ':id',
          name: 'purchase-items-detail',
          component: () => import('@/views/equipment-storage/purchase-items/Detail'),
          meta: {
            title: 'Purchase items (ID: 0)',
            roles: ['general_manager', 'equipment_storage_manager', 'equipment_storage_storekeeper']
          },
        },
      ]
    },
  ]
}
